// extracted by mini-css-extract-plugin
export default {"listItem":"PrivacyPolicy_listItem__qea4L"};